module.exports = __webpack_public_path__ + "html/week4_be107073bc11a3eda14ce6557a397430.html";


//////////////////
// WEBPACK FOOTER
// ./app/assets/html/education/week4.html
// module id = Wmao
// module chunks = 151